var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"055095c4c685e9dd91b43b944276a997a26048d7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hoyer-xp@harlapp-gmbh"]={id:"055095c4c685e9dd91b43b944276a997a26048d7"};
      